var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function FormWrapper(_a) {
    var children = _a.children, onSubmit = _a.onSubmit;
    return (_jsx("form", __assign({ onSubmit: onSubmit, className: "w-full max-w-[856px] space-y-4 animate-fade-left" }, { children: children })));
}
